var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOfficeBuilding = function SvgOfficeBuilding(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M23.25 23.25H.75M.75 23.25V1.75c0-.6.4-1 1-1h14c.6 0 1 .4 1 1v21.5M16.75 10.25h5.5c.6 0 1 .4 1 1v12"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1.5,
    d: "M7 3.75H4v4h3zM13.5 3.75h-3v4h3zM7 11.25H4v4h3zM13.5 11.25h-3v4h3zM6.95 23.25v-3.3c0-1 .8-1.8 1.8-1.8s1.8.8 1.8 1.8v3.3"
  })));
};
export default SvgOfficeBuilding;